export const LangCode = {
    EN: "en",
    ES: "es",
    FR: "fr",
    DE: "de",
    IT: "it",
    JA: "ja",
    HE: "he",
};
